export const allianceType = {
  skyteam: "SkyTeam",
  oneworld: "oneworld",
  value: "Value",
  star: "Star",
};
